export const uk = {
    'banner-id': '№ {bannerId}'
};
